import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "roomTableTr"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {} }, [
  /*#__PURE__*/_createTextVNode("   "),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 2,
  class: "mc gradBlueBg rad6 mb3",
  style: {"width":"12px","height":"12px"}
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 4,
  class: "fixedAppoContent pad8"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "ofh fl",
  style: {"height":"140px","width":"110px"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "fs10 fr greyColor",
  style: {"margin-right":"10px"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "fl fs12 greyColor mt2 ml20"
}
const _hoisted_15 = {
  key: 3,
  class: "fl fs12 greyColor mt2 ml15"
}
const _hoisted_16 = {
  key: 4,
  class: "fs11",
  style: {}
}
const _hoisted_17 = { key: 5 }
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 6 }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 7,
  class: "lgreyBg fs12 pad5 ml15 rad5 fl"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 8,
  class: "fl ml15 lgrey"
}
const _hoisted_24 = { class: "fl mt5 fs12 fw400 ddgrey" }
const _hoisted_25 = {
  key: 9,
  class: "fl ml15 lgrey"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`fl fw400 pointer ml10 mb10`),
  style: {"margin-top":"0px"}
}
const _hoisted_29 = {
  key: 0,
  class: "fl"
}
const _hoisted_30 = { class: "fl" }
const _hoisted_31 = {
  key: 1,
  class: "fl"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["onMouseover"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "grey" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src", "onClick"]
const _hoisted_42 = ["src", "onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_45 = { class: "fs16 dgrey fl mr15" }
const _hoisted_46 = { class: "fl" }
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = { key: 1 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = { key: 3 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = { class: "w100 llgreyBg padw5" }
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(`fixedAppoContent mt10 mb10 fl mr10`)
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "mt2 fw600 fs16" }, "詳細", -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = { class: "fl" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "fs10 centered ddgrey fw600" }, "提案中", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = { class: "fs16 centered ddgrey" }
const _hoisted_68 = {
  key: 0,
  class: "fs24 fw600"
}
const _hoisted_69 = {
  key: 1,
  class: "fs24 fw600"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "件", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "fs11 centered ddgrey mt4" }, "今後の"),
  /*#__PURE__*/_createElementVNode("p", { class: "fs18 centered ddgrey" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw600" }, "確定")
  ])
], -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "fs10 centered ddgrey" }, "30日間", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = { class: "fs16 centered ddgrey" }
const _hoisted_76 = {
  key: 0,
  class: "fs24 fw600"
}
const _hoisted_77 = {
  key: 1,
  class: "fs24 fw600"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "PV", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_80 = {
  key: 4,
  class: "fr arial centered",
  style: {"margin-top":"-10px"}
}
const _hoisted_81 = ["src"]
const _hoisted_82 = ["src"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, "作成", -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { style: {"margin-top":"3px","margin-left":"-3px"} }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconStar = _resolveComponent("IconStar")!
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_AlertBadge = _resolveComponent("AlertBadge")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_RoomCellEditMenu = _resolveComponent("RoomCellEditMenu")!
  const _component_PublicRoomStatusMenu = _resolveComponent("PublicRoomStatusMenu")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        (!_ctx.isSP)
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              class: _normalizeClass(`roomTableTd centered ${_ctx.bgColor()} posRe`),
              style: {"width":"120px"}
            }, [
              (_ctx.room.is_voted)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "posAb",
                    style: _normalizeStyle({ height: `100%`, top: 0, left: 0, width: `8px`, background: `#${_ctx.votedBgColor}` })
                  }, _hoisted_3, 4))
                : _createCommentVNode("", true),
              _createVNode(_component_IconStar, {
                starred: _ctx.checkStarred,
                onPushStar: _ctx.pushStar
              }, null, 8, ["starred", "onPushStar"]),
              (_ctx.room)
                ? (_openBlock(), _createBlock(_component_tooltip, {
                    key: 1,
                    text: "コピーしました!",
                    trigger: "manual",
                    modelValue: _ctx.showTip,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTip) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", {
                        class: "fs10 ddgreyColor",
                        style: {"line-height":"12px"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyPublicId && _ctx.copyPublicId(...args)))
                      }, _toDisplayString(_ctx.room.public_id), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.showConnectInstantRoomIcon)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode("   ")
                  ])), [
                    [
                      _directive_tooltip,
                      `スグINボタンが紐付いています`,
                      void 0,
                      { click: true }
                    ]
                  ])
                : _createCommentVNode("", true),
              (_ctx.room.assign_form_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_assign.png`),
                      width: "16",
                      height: "17",
                      class: "pointer ml5"
                    }, null, 8, _hoisted_6), [
                      [_directive_tooltip, `振り分けフォームが紐づいています`]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", {
                class: _normalizeClass(`fs11 ${_ctx.roomLabels()}`)
              }, _toDisplayString(_ctx.roomLabelName), 3),
              (_ctx.appo)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_tooltip, {
                      text: "コピーしました!",
                      trigger: "manual",
                      modelValue: _ctx.showAppoTip,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAppoTip) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_ctx.appo.status == 10)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "fs11 ddgreyColor",
                              style: {"line-height":"12px"},
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyAppoText && _ctx.copyAppoText(...args)))
                            }, _toDisplayString(_ctx.appo.jp_format), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_ctx.selectedMagTeamName)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "circle_button fs11",
                          style: {"padding":"2px 15px","border":"1px solid #3d543d"},
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchByMag && _ctx.searchByMag(...args)))
                        }, [
                          _createTextVNode(" 担当: "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.truncate(_ctx.selectedMagTeamName, 5)), 1)
                        ])), [
                          [
                            _directive_tooltip,
                            _ctx.selectedMagTeamName,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_8
            ], 2))
          : (_openBlock(), _createElementBlock("td", {
              key: 1,
              class: _normalizeClass(`roomTableTd ${_ctx.bgColor()}`),
              style: {"width":"2px"}
            }, null, 2)),
        _createElementVNode("td", {
          colspan: "2",
          onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.goRoom(_ctx.room)), ["self"])),
          style: {},
          class: _normalizeClass(`posRe roomTableTd`)
        }, [
          (!_ctx.isSP && _ctx.hasImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`${_ctx.room.appeal_content.image_url}`),
                  height: "140",
                  width: "110",
                  style: {"object-fit":"cover"},
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goRoom(_ctx.room)))
                }, null, 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(`${_ctx.isSP ? `fs16 posRe w100 mt20` : `fs15`} pad10 fl fw600`),
            style: _normalizeStyle(_ctx.isSP ? {} : _ctx.hasImage ? { width: `calc( 100% - 110px )` } : { width: `100%` })
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(`fl ${_ctx.isSP ? `fs18 mb10` : ``}`)
            }, "■ " + _toDisplayString(_ctx.title), 3),
            (_ctx.isSP && _ctx.room.expired_at && _ctx.room.expired_at != -1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.room.expiredLastText), 1))
              : _createCommentVNode("", true),
            (_ctx.room.room_setting && _ctx.room.room_setting.share_type == `self`)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                  _withDirectives(_createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/lock_grey.png`),
                    width: "14",
                    height: "14",
                    class: "ml10 fl"
                  }, null, 8, _hoisted_13), [
                    [
                      _directive_tooltip,
                      `共有していない調整ページ`,
                      void 0,
                      { top: true }
                    ]
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isSP && _ctx.room.expired_at && _ctx.room.expired_at != -1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createTextVNode(" 有効期限 "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.room.expiredLastText), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isSP)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                  _createTextVNode(" 最終更新 "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.room.updatedAtText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.room.owner)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _createVNode(_component_UserIcon, {
                    member: _ctx.room.owner,
                    width: 22,
                    canEdit: false,
                    updateSelf: false,
                    showTooltip: true,
                    tooltipName: `オーナー: ${_ctx.room.owner.name}`,
                    class: "fl ml10"
                  }, null, 8, ["member", "tooltipName"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.appo && _ctx.appo.fix_type == 1)
              ? (_openBlock(), _createElementBlock("label", _hoisted_17, [
                  _withDirectives(_createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/vote.png`),
                    width: "20",
                    height: "20",
                    class: "fl pointer ml15 mt1"
                  }, null, 8, _hoisted_18), [
                    [_directive_tooltip, `提案形式`]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.room?.room_setting?.chukai_is_create_pub_room_if_voted)
              ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                  _withDirectives(_createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/auto_select.png`),
                    width: "20",
                    height: "20",
                    class: "fl pointer ml15 mt1"
                  }, null, 8, _hoisted_20), [
                    [_directive_tooltip, `提案完了時に公開ページを自動作成します`]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.appo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                    width: "14",
                    height: "14",
                    class: "fl mr4 ml2"
                  }, null, 8, _hoisted_22),
                  _createTextVNode(" " + _toDisplayString(_ctx.appo.duration) + "分 ", 1)
                ]))
              : _createCommentVNode("", true),
            ((_ctx.room.is_owner || _ctx.room.is_shared) && _ctx.room.owner_avaialble_schedule_tag_name)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_CalendarIcon, {
                    astag: null,
                    astagColor: _ctx.room.owner_avaialble_schedule_tag_color,
                    width: 30,
                    iconWidth: 30,
                    totalHeight: 30,
                    canDelete: false,
                    hideName: true,
                    hideBorder: true,
                    classes: `fl`,
                    style: `margin-top:-2px;`
                  }, null, 8, ["astagColor"]),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.truncate(_ctx.room.owner_avaialble_schedule_tag_name, 18)), 1)
                ])), [
                  [_directive_tooltip, _ctx.tooltipAstagText]
                ])
              : _createCommentVNode("", true),
            ((_ctx.room.is_owner || _ctx.room.is_shared) && _ctx.room?.sub_available_schedule_tag?.available_schedule_tag_id)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createVNode(_component_CalendarIcon, {
                    astag: null,
                    astagColor: _ctx.room?.sub_available_schedule_tag?.color,
                    width: 30,
                    iconWidth: 30,
                    totalHeight: 30,
                    canDelete: false,
                    hideName: true,
                    hideBorder: true,
                    classes: `fl`,
                    style: `margin-top:-2px;`
                  }, null, 8, ["astagColor"])
                ])), [
                  [_directive_tooltip, _ctx.tooltipSubAstagText]
                ])
              : _createCommentVNode("", true),
            (_ctx.room.room_type == `public_room`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 10,
                  class: "fl ml15 dgrey fs12 lgreyBg padw4 rad5 pointer fw400 hoverGreyBg",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.editPrivateMemo && _ctx.editPrivateMemo(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                    style: {"width":"14px","height":"15px","margin-top":"-4px"}
                  }, null, 8, _hoisted_26),
                  _createTextVNode(" 管理用に設定 ")
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_AlertBadge, {
              num: _ctx.doesUnreads,
              display: `nonum`,
              class: "fr",
              style: {"margin-left":"20px"}
            }, null, 8, ["num"]),
            _hoisted_27
          ], 6),
          (_ctx.room.room_type == `parent_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_ctx.rm.isChukaiPlan())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fs16 dgrey fl mr15",
                      onMouseover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.mouseoverOpenScheduleMemo && _ctx.mouseoverOpenScheduleMemo(...args))),
                      onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.mouseleaveOpenScheduleMemo && _ctx.mouseleaveOpenScheduleMemo(...args)))
                    }, [
                      (_ctx.Util.isPresent(_ctx.room.open_schedule_memo))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.truncate(_ctx.room.open_schedule_memo, 20)), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, "調整相手への連絡事項を設定できます。")),
                      (_ctx.isHoverOpenScheduleMemo)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "fl dgrey fs12 lgreyBg padw4 rad5 pointer hoverGreyBg",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.editOpenScheduleMemo && _ctx.editOpenScheduleMemo(...args)))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                              style: {"width":"13px","height":"14px","margin-top":"-4px"}
                            }, null, 8, _hoisted_32),
                            _createTextVNode(" 編集 ")
                          ]))
                        : _createCommentVNode("", true)
                    ], 32))
                  : _createCommentVNode("", true),
                (_ctx.rm.isChukaiPlan())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.room.attendees, (_mem, memindex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(`${_ctx.isSP ? `fs14` : `fs14 fw600 pointer`}`),
                          style: {"line-height":"24px"},
                          key: memindex,
                          onMouseover: ($event: any) => (_ctx.mouseoverMember(_mem, memindex)),
                          onMouseleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.mouseleaveMember && _ctx.mouseleaveMember(...args)))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`fl mr5 ${_ctx.currentMemIndex == memindex ? `bb1` : ``}`)
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_mem.name), 1),
                            (_mem.company_name)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(`dgrey ${_ctx.isSP ? `fs12` : `fs12`}`)
                                }, "(" + _toDisplayString(_mem.company_name) + ")", 3))
                              : _createCommentVNode("", true)
                          ], 2),
                          (_ctx.Util.isPresent(_mem.private_memo))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "fl mr5 pointer",
                                onClick: ($event: any) => (_ctx.clickFormMember(_mem))
                              }, [
                                _createElementVNode("span", _hoisted_37, [
                                  _createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/chat.png`),
                                    class: "mr3",
                                    style: {"width":"18px","margin-top":"-2px"}
                                  }, null, 8, _hoisted_38),
                                  _createTextVNode(_toDisplayString(_ctx.truncate(_mem.private_memo, 10)), 1)
                                ])
                              ], 8, _hoisted_36))
                            : _createCommentVNode("", true),
                          (_ctx.Room.sharedCalendar(_ctx.room, _mem))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/calendarL.png`),
                                  style: {"width":"16px","height":"15px","margin":"0px 5px"}
                                }, null, 8, _hoisted_40)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.currentMemIndex == memindex)
                            ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/search_icon.png`),
                                width: "16",
                                height: "17",
                                class: "pointer ml5",
                                onClick: ($event: any) => (_ctx.searchByMember(_mem))
                              }, null, 8, _hoisted_41)), [
                                [_directive_tooltip, `このメンバーの調整ページを検索`]
                              ])
                            : _createCommentVNode("", true),
                          (_ctx.currentMemIndex == memindex && _mem.answered_status == `done`)
                            ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: 3,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                                width: "16",
                                height: "17",
                                class: "pointer ml5",
                                onClick: ($event: any) => (_ctx.clickFormMember(_mem))
                              }, null, 8, _hoisted_42)), [
                                [_directive_tooltip, `フォーム確認`]
                              ])
                            : _createCommentVNode("", true),
                          _hoisted_43
                        ], 42, _hoisted_35))
                      }), 128))
                    ])),
                _hoisted_44
              ]))
            : _createCommentVNode("", true),
          (_ctx.room.room_type == `public_room`)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(`fl fw400 pointer ${_ctx.isSP ? `mb10 pad10` : ``}`),
                style: _normalizeStyle(_ctx.isSP ? {} : _ctx.hasImage ? { width: `500px`, padding: `0 10px` } : { width: `610px`, padding: `0 10px` })
              }, [
                (_ctx.room.private_memo)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "",
                      onMouseover: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.mouseoverPrivateMemo && _ctx.mouseoverPrivateMemo(...args))),
                      onMouseleave: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.mouseleavePrivateMemo && _ctx.mouseleavePrivateMemo(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.room.private_memo), 1),
                        (_ctx.isHoverPrivateMemo)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "fl dgrey fs12 lgreyBg padw4 rad5 pointer hoverGreyBg",
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.editPrivateMemo && _ctx.editPrivateMemo(...args)))
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/create_event.png`),
                                style: {"width":"13px","height":"14px","margin-top":"-4px"}
                              }, null, 8, _hoisted_47),
                              _createTextVNode(" 編集 ")
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_48
                    ], 32))
                  : _createCommentVNode("", true),
                _hoisted_49,
                _createElementVNode("div", null, [
                  (_ctx.room.assign_form_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _withDirectives(_createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/form_assign.png`),
                          width: "16",
                          height: "17",
                          class: "pointer ml5 fl mr5 mt4"
                        }, null, 8, _hoisted_51), [
                          [_directive_tooltip, `振り分けフォームのURL`]
                        ]),
                        _createVNode(_component_tooltip, {
                          text: "コピーしました!",
                          trigger: "manual",
                          modelValue: _ctx.showUrlTip,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.showUrlTip) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", {
                              class: _normalizeClass(`${_ctx.isSP ? `fs16 fw600` : `fs14 fw600`} skyblue arial fl mt4 mr10`),
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.copyBoardUrl && _ctx.copyBoardUrl(...args)))
                            }, _toDisplayString(_ctx.boardUrl), 3)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_CopyButton, {
                          linkUrl: _ctx.boardUrl,
                          gtagCategory: `振り分けフォームのURLをコピー`,
                          class: "fl"
                        }, null, 8, ["linkUrl"]),
                        _hoisted_52
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createVNode(_component_tooltip, {
                          text: "コピーしました!",
                          trigger: "manual",
                          modelValue: _ctx.showUrlTip,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showUrlTip) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", {
                              class: _normalizeClass(`${_ctx.isSP ? `fs16 fw600` : `fs14 fw600`} skyblue arial fl mt4 mr10`),
                              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.copyPageUrl && _ctx.copyPageUrl(...args)))
                            }, _toDisplayString(_ctx.room.page_url), 3)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_CopyButton, {
                          linkUrl: _ctx.room.page_url,
                          gtagCategory: `公開ページのURLをコピー`,
                          class: "fl"
                        }, null, 8, ["linkUrl"]),
                        _hoisted_54
                      ]))
                ])
              ], 6))
            : _createCommentVNode("", true),
          (_ctx.isSP)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  (_ctx.room.is_owner_group && _ctx.room.status != -10)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(`circle_button fw400 fl centered fs12 blueAround pad10 mr5 mt5 with_white_bg`),
                        style: {"width":"60px","height":"48px"},
                        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.getRoomMembersLink && _ctx.getRoomMembersLink(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/link.png`),
                          width: "18",
                          height: "18",
                          class: "mt2"
                        }, null, 8, _hoisted_58)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.appo && _ctx.appo.status == 10)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createVNode(_component_tooltip, {
                          text: "コピーしました!",
                          trigger: "manual",
                          modelValue: _ctx.showAppoTip,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showAppoTip) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", {
                              class: "fs14 fw800 ddgreyColor",
                              style: {"line-height":"12px"},
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.copyAppoText && _ctx.copyAppoText(...args)))
                            }, _toDisplayString(_ctx.appo.jp_format), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.selectedMagTeamName)
                          ? _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "circle_button fs11",
                              style: {"padding":"2px 15px","border":"1px solid #3d543d"},
                              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.searchByMag && _ctx.searchByMag(...args)))
                            }, [
                              _createTextVNode(" 担当: "),
                              _createElementVNode("span", null, _toDisplayString(_ctx.truncate(_ctx.selectedMagTeamName, 5)), 1)
                            ])), [
                              [_directive_tooltip, _ctx.selectedMagTeamName]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "circle_button fl centered blueAround pad10 mr10 mt5 with_white_bg rad10",
                    style: {"width":"60px","height":"48px"},
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.goRoom(_ctx.room)))
                  }, _hoisted_61),
                  _hoisted_62
                ]),
                _hoisted_63
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_64, [
            (
                        !_ctx.isSP &&
                        _ctx.room.room_type == `public_room` &&
                        (_ctx.room.rooms_voted_num != 0 || _ctx.Util.isPresent(_ctx.room.rooms_voted))
                    )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`${
                        _ctx.rm.userInfo && _ctx.room.is_owner_group ? `circle_button orangeAround pointer` : ``
                    } fr arial centered rad10 ml10 yellowBg`),
                  style: {"padding":"2px 10px","margin-bottom":"0","min-width":"70px"},
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.clickVoted(_ctx.room)))
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_65,
                    _hoisted_66,
                    _createElementVNode("span", _hoisted_67, [
                      (_ctx.room.rooms_voted)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString((_ctx.room.rooms_voted || []).length), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.room.rooms_voted_num), 1)),
                      _hoisted_70
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (!_ctx.isSP && _ctx.room.status != -10 && _ctx.room.room_type == `public_room` && _ctx.room.is_owner_group)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(`${
                        _ctx.rm.userInfo && _ctx.room.is_owner_group ? `circle_button greenAround pointer` : ``
                    } fr arial centered rad10 ml10`),
                  style: _normalizeStyle(_ctx.isSP ? { marginTop: `-10px` } : { padding: `2px 10px`, minWidth: `70px` }),
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.goSummaryFixed(_ctx.room)))
                }, _hoisted_72, 6))
              : _createCommentVNode("", true),
            (!_ctx.isSP && _ctx.room.status != -10 && _ctx.room.room_type == `public_room`)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(`${
                        _ctx.rm.userInfo && _ctx.room.is_owner_group ? `circle_button blueAround pointer` : ``
                    } fr arial centered rad10`),
                  style: _normalizeStyle(_ctx.isSP ? { marginTop: `-10px` } : { padding: `2px 10px`, minWidth: `70px` }),
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.clickSummary(_ctx.room)))
                }, [
                  _createElementVNode("div", null, [
                    _hoisted_73,
                    _hoisted_74,
                    _createElementVNode("span", _hoisted_75, [
                      (_ctx.Util.isPresent(_ctx.room.access_stats))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.room.access_stats.page_view_total), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_77, "0")),
                      _hoisted_78
                    ])
                  ])
                ], 6))
              : _createCommentVNode("", true),
            _hoisted_79
          ]),
          (_ctx.room.memo && !_ctx.isSP)
            ? (_openBlock(), _createElementBlock("p", _hoisted_80, [
                _withDirectives(_createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/memo_bold.png`),
                  width: "20",
                  height: "20",
                  class: "fl pointer",
                  style: {"margin-right":"16px","margin-top":"45px"}
                }, null, 8, _hoisted_81), [
                  [
                    _directive_tooltip,
                    `公開メモ\n${_ctx.room.memo}`,
                    void 0,
                    { top: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSP)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                style: {"width":"320px"},
                class: _normalizeClass(`fr ${_ctx.hasImage ? `mt10` : ``}`),
                onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (_ctx.goRoom(_ctx.room)), ["self"]))
              }, [
                (_ctx.room.is_owner_group)
                  ? (_openBlock(), _createBlock(_component_RoomCellEditMenu, {
                      key: 0,
                      room: _ctx.room,
                      canDelete: _ctx.canDelete,
                      onCopyPage: _ctx.copyPage,
                      onEditPage: _ctx.editPage,
                      onShowCloseRoomModal: _ctx.showCloseRoomModal,
                      onGoSummary: _ctx.clickSummary,
                      onGoSummaryNotFixed: _ctx.goSummaryNotFixed,
                      onCancelVoted: _ctx.cancelVoted,
                      onCancelAppo: _ctx.cancelAppo,
                      onCreateFeedback: _ctx.createFeedback,
                      onClickEditMenu: _ctx.clickEditMenu,
                      onChangeActive: _ctx.changeActive,
                      onShowShareAuthModal: _ctx.showShareAuthModal
                    }, null, 8, ["room", "canDelete", "onCopyPage", "onEditPage", "onShowCloseRoomModal", "onGoSummary", "onGoSummaryNotFixed", "onCancelVoted", "onCancelAppo", "onCreateFeedback", "onClickEditMenu", "onChangeActive", "onShowShareAuthModal"]))
                  : _createCommentVNode("", true),
                (_ctx.room.is_owner_group && _ctx.room.status != -10)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 1,
                      class: _normalizeClass(`circle_button fw400 fr centered fs12 blueAround`),
                      style: {"width":"60px","padding":"4px 10px","margin-right":"10px"},
                      onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.getRoomMembersLink && _ctx.getRoomMembersLink(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/link.png`),
                        width: "14",
                        height: "14",
                        style: {"margin-top":"-2px"}
                      }, null, 8, _hoisted_82)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.room.room_type == `parent_room`)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 2,
                      class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround hoverSkyblueBg`),
                      style: {"width":"110px","padding":"4px 10px","margin-right":"10px"},
                      onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.goRoom(_ctx.room)))
                    }, " 調整ページへ "))
                  : _createCommentVNode("", true),
                (_ctx.room.room_type == `public_room`)
                  ? (_openBlock(), _createBlock(_component_PublicRoomStatusMenu, {
                      key: 3,
                      room: _ctx.room,
                      onChangeStatus: _ctx.changeStatus
                    }, null, 8, ["room", "onChangeStatus"]))
                  : _createCommentVNode("", true),
                (_ctx.room.room_type == `parent_room` && _ctx.room.is_valid && _ctx.room.status == -10)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 4,
                      class: _normalizeClass(`circle_button fw600 fr centered fs12 pinkBg`),
                      style: _normalizeStyle(
                        _ctx.room.is_valid
                            ? { width: `80px`, padding: `5px 12px`, marginRight: `10px` }
                            : { width: `130px`, padding: `5px 12px`, marginRight: `10px` }
                    ),
                      onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.createRoom && _ctx.createRoom(...args)))
                    }, _hoisted_84, 4))
                  : _createCommentVNode("", true),
                (!_ctx.room.is_valid && _ctx.room.invalid_messages)
                  ? (_openBlock(), _createBlock(_component_tooltip, {
                      key: 5,
                      text: _ctx.room.invalid_messages.join(`<br />`),
                      trigger: "hover"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.room.room_type == `parent_room` && _ctx.room.status == -10)
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              class: _normalizeClass(`circle_button fw600 fr centered fs12 ${_ctx.room.is_valid ? `pinkBg` : `lgreyBg`}`),
                              style: _normalizeStyle(
                            _ctx.room.is_valid
                                ? { width: `80px`, padding: `5px 12px`, marginRight: `10px` }
                                : { width: `130px`, padding: `5px 12px`, marginRight: `10px` }
                        ),
                              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.createRoom && _ctx.createRoom(...args)))
                            }, [
                              _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.room.is_valid ? `作成` : `作成できません`), 1)
                            ], 6))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true),
                _hoisted_86
              ], 2))
            : _createCommentVNode("", true),
          _hoisted_87
        ])
      ]))
    : _createCommentVNode("", true)
}